import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { QuotingToolService } from '../../quoting-tool.service';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/core/services/notification.service';
import { FileIconService } from 'src/app/core/helper/file-icon.service';

@Component({
  selector: 'app-project-docs',
  templateUrl: './project-docs.component.html'
})
export class ProjectDocsComponent implements OnInit {

  imagePath:any=environment.image_path;

  currencyFlag:number=2; // 1=INR , 2=Doller

  ProductRequirement!:FormGroup;
  projectID:any;
  uniqueID:any;
  iProductRequirementId:any;
  rangeDisabled:boolean=false;

  //upload files
  selectedFile: File | null = null;
  uploadedFiles: any[] = [];
  submittedDocuments:any[]=[];


  constructor(public fileIconService:FileIconService,private notifyService: NotificationService,private quotingService:QuotingToolService) { }

  ngOnInit(): void {
    this.projectID = localStorage.getItem('projectID');
    this.uniqueID = localStorage.getItem('ID');
    localStorage.setItem('currentStepIndex', '1');

    this.ProductRequirement = new FormGroup({
      // vProjectName: new FormControl("", [Validators.maxLength(100)]),
      vProjectDescription: new FormControl("",[Validators.maxLength(1000)]),
      iMinPrice: new FormControl(10000),
      iMaxPrice: new FormControl(1000000),
      iDontKnow: new FormControl(false),
      vReferenceLink: new FormControl('', [Validators.pattern(/^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(:[0-9]{1,5})?(\/[a-zA-Z0-9-._~:\/?#\[\]@!$&'()*+,;=]*)?$/)])
    });

    this.GetProductRequirements();
  }

  SubmitProductRequirement(){
    if (this.ProductRequirement.invalid || this.uploadedFiles.length>10){
      this.ProductRequirement.markAllAsTouched();
      if(this.uploadedFiles.length>10){
        this.notifyService.showError('Max up to 10 files can be uploaded', '');
      }
      return;
    }

    if(this.ProductRequirement.value.iDontKnow==false && this.ProductRequirement.value.iMinPrice>this.ProductRequirement.value.iMaxPrice){
      this.notifyService.showError('Invalid range for budget', '');
      return;
    }

    const files = this.uploadedFiles.filter((file:any)=>{
      if(file.hasOwnProperty('_id')===false){
        return file;
      }
    });

    let reqJson={
      iProjectId:this.uniqueID,
      iProductRequirementId:null,
      iCurrencyStatus:this.currencyFlag, // 1=INR , 2=Doller
      // vProjectName:this.ProductRequirement.value.vProjectName,
      vProductDescription:this.ProductRequirement.value.vProjectDescription,
      iProductMinRange:this.ProductRequirement.value.iDontKnow ? null : this.ProductRequirement.value.iMinPrice,
      iProductMaxRange:this.ProductRequirement.value.iDontKnow ? null :this.ProductRequirement.value.iMaxPrice,
      isProductRangeUnknown:this.ProductRequirement.value.iDontKnow,
      vProductUrl:this.ProductRequirement.value.vReferenceLink,
      files:files
    }

    if(this.iProductRequirementId){

      reqJson.iProductRequirementId=this.iProductRequirementId;

      this.quotingService.UpdateProductRequirement(reqJson).subscribe((result: any) => {
        if (result['code'] == 200) {
          if(this.iProductRequirementId){
            this.Next();
          }
        } else {
          this.notifyService.showError(result.message, '');
        }
      });
    }else{
      this.quotingService.SaveProductRequirement(reqJson).subscribe((result: any) => {
        if (result['code'] == 200) {
          this.iProductRequirementId = localStorage.getItem('prId');
          if(this.iProductRequirementId){
            this.Next();
          }else{
            this.GetProjectRequirementIdAndRedirect();
          }
        } else {
          this.notifyService.showError(result.message, '');
        }
      });
    }
  }

  GetProductRequirements(prId?:any){
    if(prId){
      this.quotingService.GetProductRequirement(this.uniqueID,prId).subscribe((result: any) => {
        if (result['code'] == 200) {
          if(result['data'].hasOwnProperty('vProductName')){
            this.PatchProductRequirementData(result['data']);
          }
        } else {
          this.notifyService.showError(result.message, '');
        }
      });
    }else{
      this.quotingService.GetProjectDatabyID(this.projectID).subscribe((result: any) => {
        if (result.code == 200) {
          if(result.data.iProductRequirementId){
            this.iProductRequirementId=result.data.iProductRequirementId;
            localStorage.setItem("prId", result.data.iProductRequirementId);
            this.GetProductRequirements(result.data.iProductRequirementId);
          }
        } else {
          this.notifyService.showError(result.message, '');
        }
      });
    }
  }

  GetProjectRequirementIdAndRedirect() {
    this.quotingService.GetProjectDatabyID(this.projectID).subscribe((result: any) => {
        if (result.code == 200) {
          if(result.data.iProductRequirementId){
            this.iProductRequirementId=result.data.iProductRequirementId;
            localStorage.setItem("prId", result.data.iProductRequirementId);
            this.Next();
          }
        } else {
          this.notifyService.showError(result.message, '');
        }
      });
  }

  PatchProductRequirementData(data:any){
    this.rangeDisabled=data.isProductRangeUnknown;
    
    this.ProductRequirement.patchValue({
      // vProjectName: data.vProductName,
      vProjectDescription: data.vProductDescription,
      iMinPrice: data.iProductMinRange || 10000,
      iMaxPrice: data.iProductMaxRange || 1000000,
      iDontKnow: data.isProductRangeUnknown,
      vReferenceLink: data.vProductUrl
    });


    if(this.rangeDisabled){
      this.ProductRequirement.controls['iMinPrice'].disable();
      this.ProductRequirement.controls['iMaxPrice'].disable();
    }
    
    this.uploadedFiles=[...data.vProductDocuments];
    this.submittedDocuments=[...data.vProductDocuments];
  }

  DontKnowValueChange(event:any){
    if(event.checked==true){
      this.rangeDisabled=true;
      // this.ProductRequirement.controls['iMinPrice'].setValue(10000);
      // this.ProductRequirement.controls['iMaxPrice'].setValue(1000000);
      this.ProductRequirement.controls['iMinPrice'].disable();
      this.ProductRequirement.controls['iMaxPrice'].disable();
    }else{
      this.rangeDisabled=false;
      this.ProductRequirement.controls['iMinPrice'].enable();
      this.ProductRequirement.controls['iMaxPrice'].enable();
    }
  }

  onMinSliderChange(event:any){
    this.ProductRequirement.controls['iMinPrice'].setValue(event.target.value);
  }

  onMaxSliderChange(event:any){
    this.ProductRequirement.controls['iMaxPrice'].setValue(event.target.value);
  }

  hasError(form: FormGroup, controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }

  Next(){
    const newValue = Math.random() * 100;
    this.quotingService.updateEStepper(newValue);
  }


  //file upload
  triggerFileInput(): void {
    const fileInput = document.getElementById("fileUpload") as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }
 
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
    input.value='';
    const changeEvent = new Event('change');
    input.dispatchEvent(changeEvent);
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const files = event?.dataTransfer?.files;
    this.uploadFiles(files);
    event!.dataTransfer!.clearData();
  }
 
  onDragOver(event: DragEvent) {
    event.preventDefault();
  }
 
  onFileSelect(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    this.uploadFiles(files);
  }
 
  uploadFiles(files: any) {
    for (const file of files) {
      this.uploadedFiles.push(file);
    }
    if(this.uploadedFiles.length>10){
      this.notifyService.showError('Max up to 10 files can be uploaded', '');
    }
  }
 
  removeFile(index: number,_id:any) {
    if(_id){
      this.quotingService.DeleteProductFile(this.uniqueID,this.iProductRequirementId,_id).subscribe((result: any) => {
        if (result.code == 200) {
          this.uploadedFiles.splice(index, 1);
        } else {
          this.notifyService.showError(result.message, '');
        }
      });
    }else{
      this.uploadedFiles.splice(index, 1);
    }
    
  }
 
  removeAllFiles() {
    if(this.submittedDocuments.length>0){
      let count=0;
      this.submittedDocuments.forEach((element:any) => {
        const findIndex = this.uploadedFiles.findIndex((file:any)=>element._id==file._id);
        // if(element._id){
          this.quotingService.DeleteProductFile(this.uniqueID,this.iProductRequirementId,element._id).subscribe((result: any) => {
            if (result.code == 200) {
              this.uploadedFiles.splice(findIndex, 1);
            } else {
              this.notifyService.showError(result.message, '');
            }
            count++;
            if(count==this.submittedDocuments.length){
              this.uploadedFiles = [];
            }
          });
        // }
      });
    }else{
      this.uploadedFiles = [];
    }
  }
 

}
